import {
  CHANGE_PREOFFER_STATUS,
  CHANGE_PREOFFER_STATUS_FAILURE,
  CHANGE_PREOFFER_STATUS_RESET,
  CHANGE_PREOFFER_STATUS_SUCCESS,
  FETCH_BGC_COUNTS,
  FETCH_BGC_COUNTS_FAILURE,
  FETCH_BGC_COUNTS_SUCCESS,
  FETCH_PREOFFER_CANDIDATES,
  FETCH_PREOFFER_CANDIDATES_FAILURE,
  FETCH_PREOFFER_CANDIDATES_SUCCESS,
  FETCH_PREOFFER_COUNTS,
  FETCH_PREOFFER_COUNTS_FAILURE,
  FETCH_PREOFFER_COUNTS_SUCCESS,
  FETCH_SLA_COUNTS,
  FETCH_SLA_COUNTS_SUCCESS,
  OFFER_STATUS,
  OFFER_STATUS_FAILURE,
  OFFER_STATUS_RESET,
  OFFER_STATUS_SUCCESS,
  OFFER_STATUS_WITH_ATTACHMENT,
  OFFER_STATUS_WITH_ATTACHMENT_FAILURE,
  OFFER_STATUS_WITH_ATTACHMENT_RESET,
  OFFER_STATUS_WITH_ATTACHMENT_SUCCESS,
} from "./actionTypes";

export const fetchPreOfferCandidates = (params) => ({
  type: FETCH_PREOFFER_CANDIDATES,
  payload: params,
});

export const fetchPreOfferCandidatesSuccess = (candidates) => ({
  type: FETCH_PREOFFER_CANDIDATES_SUCCESS,
  payload: candidates,
});

export const fetchPreOfferCandidatesFailure = (error) => ({
  type: FETCH_PREOFFER_CANDIDATES_FAILURE,
  payload: error,
});

export const fetchPreOfferCounts = (params) => ({
  type: FETCH_PREOFFER_COUNTS,
  payload: params,
});

export const fetchPreOfferCountsSuccess = (counts) => ({
  type: FETCH_PREOFFER_COUNTS_SUCCESS,
  payload: counts,
});

export const fetchPreOfferCountsFailure = (error) => ({
  type: FETCH_PREOFFER_COUNTS_FAILURE,
  payload: error,
});

export const fetchSLACounts = (params) => ({
  type: FETCH_SLA_COUNTS,
  payload: params,
});

export const fetchSLACountsSuccess = (counts) => ({
  type: FETCH_SLA_COUNTS_SUCCESS,
  payload: counts,
});

export const fetchSLACountsFailure = (error) => ({
  type: FETCH_BGC_COUNTS_FAILURE,
  payload: error,
});

export const fetchBGCCounts = (params) => ({
  type: FETCH_BGC_COUNTS,
  payload: params,
});

export const fetchBGCCountsSuccess = (counts) => ({
  type: FETCH_BGC_COUNTS_SUCCESS,
  payload: counts,
});

export const fetchBGCCountsFailure = (error) => ({
  type: FETCH_BGC_COUNTS_FAILURE,
  payload: error,
});

export const changeStatus = (params) => ({
  type: CHANGE_PREOFFER_STATUS,
  payload: params,
});

export const changeStatusSuccess = (status) => ({
  type: CHANGE_PREOFFER_STATUS_SUCCESS,
  payload: status,
});

export const changeStatusFailure = (error) => ({
  type: CHANGE_PREOFFER_STATUS_FAILURE,
  payload: error,
});

export const resetChangeStatus = () => ({
  type: CHANGE_PREOFFER_STATUS_RESET,
});

export const offerStatus = (params) => ({
  type: OFFER_STATUS,
  payload: params,
});

export const offerStatusSuccess = (status) => ({
  type: OFFER_STATUS_SUCCESS,
  payload: status,
});

export const offerStatusFailure = (error) => ({
  type: OFFER_STATUS_FAILURE,
  payload: error,
});

export const resetOfferStatus = () => ({
  type: OFFER_STATUS_RESET,
});

export const offerStatusWithAttachments = (params) => ({
  type: OFFER_STATUS_WITH_ATTACHMENT,
  payload: params,
});

export const offerStatusWithAttachmentsSuccess = (status) => ({
  type: OFFER_STATUS_WITH_ATTACHMENT_SUCCESS,
  payload: status,
});

export const offerStatusWithAttachmentsFailure = (error) => ({
  type: OFFER_STATUS_WITH_ATTACHMENT_FAILURE,
  payload: error,
});

export const resetOfferWithAttachmentsStatus = () => ({
  type: OFFER_STATUS_WITH_ATTACHMENT_RESET,
});
